var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"reset-all-styles",domProps:{"innerHTML":_vm._s(_vm.page.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }